import SessionEventProto from "../session-event-proto";

export default class SessionEvent_AutomationLimitReached extends SessionEventProto {

    // private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        // this.header     = {
        //     expense     : sessionEvent.expense,
        //     isBulkUpdate: sessionEvent.isBulkUpdate,
        // }
    }

    process() {

        if (this.isDifferentCompany()) return false;

        gd.growl.warning("Automation cascade limit reached. No future automations will be run.")
    }
};
